import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { EventDateTimeProps } from '../../../types';
import { getFormattedDate, isSameDay } from '../../utils/localizedDates';

export const EventDetailsDateTime = (props: EventDateTimeProps) => {
    const {
        end,
        hideEndDate,
        hideStartDate,
        isOnlineEvent,
        isSeriesParent,
        locale,
        start,
    } = props;

    if (isSeriesParent) {
        return null;
    }

    if (hideEndDate && hideStartDate) {
        return null;
    }

    if (hideEndDate) {
        return (
            <p
                data-testid="event-details-date-time-first-line"
                className="eds-text-bm"
            >
                {getFormattedDate({
                    date: start,
                    format: 'ddd, ll, LT',
                    isOnlineEvent,
                    localizedFormat: 'ddd, ll, LT z',
                    locale,
                })}
            </p>
        );
    }

    if (hideStartDate) {
        return (
            <p
                data-testid="event-details-date-time-first-line"
                className="eds-text-bm"
            >
                {gettext('Ends on')}{' '}
                {getFormattedDate({
                    date: end,
                    format: 'ddd, ll, LT',
                    isOnlineEvent,
                    localizedFormat: 'ddd, ll, LT z',
                    locale,
                })}
            </p>
        );
    }

    if (isSameDay({ end, isOnlineEvent, start })) {
        return (
            <>
                <p
                    data-testid="event-details-date-time-first-line"
                    className="eds-text-bm"
                >
                    {getFormattedDate({
                        date: start,
                        format: 'ddd, LL',
                        isOnlineEvent,
                        locale,
                    })}
                </p>
                <p
                    data-testid="event-details-date-time-second-line"
                    className="eds-text-bm"
                >
                    {getFormattedDate({
                        date: start,
                        format: 'LT – ',
                        isOnlineEvent,
                        locale,
                    })}
                    {getFormattedDate({
                        date: end,
                        format: 'LT',
                        localizedFormat: 'LT z',
                        isOnlineEvent,
                        locale,
                    })}
                </p>
            </>
        );
    }

    return (
        <>
            <p
                data-testid="event-details-date-time-first-line"
                className="eds-text-bm"
            >
                {getFormattedDate({
                    date: start,
                    format: 'ddd, ll, LT –',
                    isOnlineEvent,
                    locale,
                })}
            </p>
            <p
                data-testid="event-details-date-time-second-line"
                className="eds-text-bm"
            >
                {getFormattedDate({
                    date: end,
                    format: 'ddd, ll, LT',
                    localizedFormat: 'ddd, ll, LT z',
                    isOnlineEvent,
                    locale,
                })}
            </p>
        </>
    );
};

export default EventDetailsDateTime;
